import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { MarketDialog } from 'src/modules/supply_chain/components/MarketDialog'
import { skuit } from 'src/services/skuit'

import { MarketListTable } from 'src/components/Table/list/Market'
import { ListPage } from 'src/components/Pages/ListPage'

export const MarketListPage = () => {
  const paginator = useQueryPaginator(
    'market-list',
    skuit.sc.markets.list
  )

  const exportFields = [
    "guid",
    "name",
  ]

  return (
    <ListPage
      title='Markets'
      paginator={paginator}
      dialogs={[{ title: 'New Market', Dialog: MarketDialog }]}
    >
      <MarketListTable
        paginator={paginator}
        fields={['name']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.markets.export
        }}
      />
    </ListPage>
  )
}
